import { useMsal } from "@azure/msal-react";

/**
 * Signed-in user's email for actor-scoped mutations (same resolution order as
 * ReviewQueue / AppShell: MSAL username → preferred_username → upn → email).
 */
export function useActorEmail(): string {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() ?? accounts[0];
  const claims = (account?.idTokenClaims ?? {}) as Record<string, unknown>;
  const claimStr = (k: string) =>
    typeof claims[k] === "string" ? (claims[k] as string).trim() : "";
  return (
    (account?.username && account.username.trim()) ||
    claimStr("preferred_username") ||
    claimStr("upn") ||
    claimStr("email") ||
    ""
  );
}
